<div
    class="coloredIconWrapper"
    [ngClass]="iconColor"
    appTooltip
    [componentData]="tooltipText ?? '' | translate"
    position="top"
    trigger="hover"
>
    @switch (iconType) {
        @case (ColoredIconTypesEnum.UNKNOWN) {
            <i class="fa fa-question"></i>
        }
        @case (ColoredIconTypesEnum.DIAMOND) {
            <i class="fa-regular fa-gem"></i>
        }
        @case (ColoredIconTypesEnum.REFRESH) {
            <i class="fa fa-repeat"></i>
        }
    }
</div>
